<mat-card class="sponsor-card" *ngIf="sponsor">
  <ng-container *ngIf="sponsor.hasWebsite(); else withoutWebsite">
    <a [href]="sponsor.url" target="_blank">
      <mat-card-content class="mb-0 mb-md-1 sponsor-card__role">
        <span
          class="sponsor-card__role--inner"
          [innerHTML]="sponsorRole">
        </span>
      </mat-card-content>
      <ng-container *ngIf="resizedImageSrc; else noImageAvailable">
        <img *ngIf="resizedImageSrc" mat-card-image [src]="resizedImageSrc" alt="Sponsor Image">
      </ng-container>
      <ng-template #noImageAvailable>
        <span>{{sponsor.name}}</span>
      </ng-template>
    </a>
  </ng-container>
  <ng-template #withoutWebsite>
    <div class="without_link">
      <mat-card-content class="mb-0 mb-md-1 sponsor-card__role">
        <span
          class="sponsor-card__role--inner"
          [innerHTML]="sponsorRole">
        </span>
      </mat-card-content>

      <ng-container *ngIf="resizedImageSrc; else noImageAvailable">
        <img *ngIf="resizedImageSrc" mat-card-image [src]="resizedImageSrc" alt="Sponsor Image">
      </ng-container>
      <ng-template #noImageAvailable>
        <span>{{sponsor.name}}</span>
      </ng-template>
    </div>
  </ng-template>
</mat-card>
